import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./forgot-password.scss";
import Logo from "../../images/academates-logo.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [resetEmailSent, setResetEmailSent] = useState(false);

  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);
      setResetEmailSent(true);
    } catch (err) {
      if (
        err.code === "auth/user-not-found" ||
        err.code === "auth/wrong-password"
      ) {
        alert("Invalid email.");
      }
    }
  };

  const handleSignIn = () => {
    navigate("/landing-page");
  };

  const handleNavigateSignUp = () => {
    navigate("/create-account");
  };

  return (
    <div className="forgot-password-container">
      <nav>
        <div className="left-nav-container">
          <img src={Logo} alt="Logo" />
          <span>Academates</span>
        </div>
        <div className="right-nav-container">
          <a href="mailto: infoacademates@gmail.com">Contact</a>
          <span onClick={handleNavigateSignUp}>Sign Up</span>
        </div>
      </nav>
      <div className="container">
        <img src={Logo} alt="Logo" />

        <div className="title">
          <h2>Forgot Password</h2>
          <p>Enter your email to receive a password reset link:</p>
        </div>
        <form>
          <input
            placeholder="Email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            maxLength={40}
          />
          <button onClick={(e) => handleResetPassword(e)} type="submit">
            Send Reset Email
          </button>
        </form>
        <span onClick={handleSignIn}>Go Back</span>

        {resetEmailSent && (
          <p>Password reset email sent. Please check your inbox.</p>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
